import { Box, Typography } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { CloudUpload } from '@mui/icons-material';
import { getReadableFileKindName, mapFileExtensionToFileType } from 'Application/utils';
import { UploadedFile } from './UploadedFile';
import { FC } from 'react';
import { FileKind } from 'Application/models';

interface KycSingleFileUploaderProps {
    fileKind: FileKind;
    onFileChange: (acceptedFiles: File[]) => void;
    onDeleteFile: (index: number) => void;
    selectedFile: File | undefined;
}

export const KycSingleFileUploader: FC<KycSingleFileUploaderProps> = ({ fileKind, onFileChange, onDeleteFile, selectedFile }) => {

    const maxFileSize = 10;

    const { getRootProps, getInputProps } = useDropzone({
        maxSize: 1024 * 1024 * maxFileSize,
        accept: {
            // 'application/msword': ['.doc'],
            // 'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.docx', '.pdf', '.pptx', '.csv', '.xlsx'],
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document': ['.pdf'],
            // 'application/vnd.ms-excel': ['.xls'],
            // 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': ['.xlsx'],
            // 'application/vnd.ms-powerpoint': ['.ppt'],
            // 'application/vnd.openxmlformats-officedocument.presentationml.presentation': ['.pptx'],
            'application/pdf': ['.pdf'],
            'image/jpeg': ['.jpeg'],
            'image/jpg': ['.jpg'],
            'image/png': ['.png'],
        },
        onDrop: (acceptedFiles) => {
            onFileChange(acceptedFiles);
        }
    });

    return (
        <Box className="container my-3">
            <Typography className="mb-4 text-sm text-slate-700 font-medium">{getReadableFileKindName(fileKind)}</Typography>
            {selectedFile === undefined ? (
                <Box
                    {...getRootProps({
                        className:
                            'flex flex-col items-center p-5 border-2 space-y-1 rounded border-dashed outline-none hover:cursor-pointer transition-colors duration-200 mb-2 dropzone'
                    })}
                >
                    <input {...getInputProps()} />
                    <CloudUpload color="primary" />
                    <Typography>
                        <span className="font-semibold text-indigo-800">Click to upload</span> or drag and drop
                    </Typography>
                    <Typography className="text-indigo-900 text-opacity-60 font-medium text-center">
                        File size upload limit is {maxFileSize} MB
                    </Typography>
                    <Typography className="text-indigo-900 text-opacity-60 font-medium text-center">
                        Allowed extensions are: pdf, jpeg, jpg & png
                    </Typography>
                </Box>
            ) : <UploadedFile
                fileType={mapFileExtensionToFileType(selectedFile.type)}
                fileSize={`${selectedFile.size} bytes`}
                fileName={selectedFile.name}
                onDeleteFile={onDeleteFile}
                index={0}
            />
            }
        </Box>
    );
};
